<template>
    <div class="card panel panel-default actions">
        <div class="card-block">
            <div class="header-block d-flex justify-content-between">
                <h3>{{actionLabel}}: <span class="font-weight-normal">{{ propertyLabel }}</span></h3>
                <div class="d-flex">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'edit-property-header-block',
    props: {
        actionLabel: {
            type: String,
            default: ''
        },
        propertyLabel: {
            type: String,
            default: ''
        }
    }
}
</script>

<style></style>